// Classifies an Open Banking connect/reconnect error response into either
// the ambiguous-provider picker state or a plain toast. Pulled out of
// IntegrationsPage.jsx's attemptObConnect so the decision logic (which is
// what actually matters -- does an ambiguous match open a picker instead
// of hard-failing?) is unit-testable without rendering the page.
export function classifyObConnectError(errData, institutionName) {
  if (errData && errData.requires_picker) {
    return {
      kind: 'picker',
      institutionId: errData.institution_id,
      candidates: errData.candidates || [],
    };
  }
  if (errData && errData.step === 'provider_resolution' && errData.error) {
    return {
      kind: 'toast',
      message: 'Provider resolution failed for ' + institutionName + ': ' + errData.error,
    };
  }
  var detail = (errData && (errData.detail || errData.error)) || 'Unknown error';
  return {
    kind: 'toast',
    message: 'Open banking connect failed: ' + detail,
  };
}
